export default "__VITE_ASSET__pa0Prv6E__"